import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CenterLoading from "components/common/CenterLoading";
import AiccBreadCrumb from "components/common/AiccBreadCrumb";
import { getPathPrefix } from "utils/coreUtils";
import companyUserApi from "services/apis/companyUserApi";
import { setSelectedDatastream } from "../store";
import { fetchDatastreamList } from "features/dashboard/store/dashboard.thunk";

function Index() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [t] = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [companyDetails, setCompanyDetails] = useState();
  const datastreamList = useSelector((state) => state?.datastream?.list);
  const companyId = localStorage.getItem("companyId");
  const companyUserId = localStorage.getItem("companyUserId");

  const getCompanyUserDetailsById = async () => {
    try {
      const companyUserDetails = await companyUserApi.getCompanyUserDetailsById(
        {
          companyUserId,
        }
      );

      setCompanyDetails(companyUserDetails.data);
      setIsLoading(false);
    } catch (error) {
      console.log("checking", error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const setupDatastream = async () => {
      setIsLoading(true);
      dispatch(fetchDatastreamList(companyId));
      await getCompanyUserDetailsById();
    };
    setupDatastream();
  }, []);

  const finalDataStreams = useMemo(() => {
    if (companyDetails?.userRoleType !== "CA") {
      return datastreamList.filter((e) =>
        companyDetails?.dataStreamConfigIds.includes(e.dataStreamConfigId)
      );
    }

    return datastreamList;
  }, [
    companyDetails?.dataStreamConfigIds,
    companyDetails?.userRoleType,
    datastreamList,
  ]);

  return (
    <>
      <AiccBreadCrumb
        homeLink={getPathPrefix("dashboard")}
        title={t("dashboard.breadCrumb.title")}
        items={t("dashboard.breadCrumb.items", {
          returnObjects: true,
        })}
      />
      <div className="row">
        <div className="col-md-12 grid-margin">
          <div className="row">
            <div className="col-12 col-xl-12 mb-4 mb-lg-5">
              <h4 className=" text-center">{t("dashboard.title")}</h4>
            </div>
            <div className="col-12">
              <div className="dashboard-card-area col-lg-9 mx-auto mb-4">
                <div className="row g-3">
                  {isLoading ? (
                    <CenterLoading />
                  ) : finalDataStreams.length > 0 ? (
                    finalDataStreams.map((e) => (
                      <div
                        className="col-lg-6 col-md-6 col-12"
                        key={e.dataStreamConfigId}
                      >
                        <div
                          className="h-100"
                          onClick={() => {
                            navigate(
                              getPathPrefix(
                                "selected-datastream/rule-engine/versions"
                              )
                            );
                            dispatch(setSelectedDatastream(e));
                          }}
                        >
                          <div
                            className="card db-card h-100"
                            style={{
                              marginBottom: "unset",
                            }}
                          >
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div
                                  style={{
                                    wordWrap: "break-word",
                                    width: "100%",
                                  }}
                                >
                                  <h4>{e.customDataStreamName}</h4>
                                  {/* <p>{e.aiccDataStreamJsons.length}</p> */}
                                </div>
                                {/* <div className="widget-icon-large ms-auto">
                                    <img
                                      src="/assets/images/estimate.png"
                                      alt
                                      className="widget-icon"
                                    />
                                    <svg
                                      className="peity"
                                      height={92}
                                      width={92}
                                    >
                                      <path
                                        d="M 46 0 A 46 46 0 1 1 13.473088065418807 13.473088065418814 L 17.008621971351545 17.008621971351555 A 41 41 0 1 0 46 5"
                                        data-value={7}
                                        fill="rgb(255, 255, 255)"
                                      />
                                      <path
                                        d="M 13.473088065418807 13.473088065418814 A 46 46 0 0 1 45.99999999999999 0 L 45.99999999999999 5 A 41 41 0 0 0 17.008621971351545 17.008621971351555"
                                        data-value={1}
                                        fill="rgba(255, 255, 255)"
                                      />
                                    </svg>
                                    <span className="circle bg-white" />
                                  </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div
                      className="align-items-center d-flex justify-content-center text-center text-no-data"
                      style={{
                        height: "60vh",
                      }}
                      dangerouslySetInnerHTML={{
                        __html: t("dashboard.notConfigured"),
                      }}
                    ></div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Index;
